import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet icon paths for Vite
// See: https://vue2-leaflet.netlify.app/quickstart/#marker-icons-are-missing
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default {
  data() {
    return {
      icon: L.icon({
        iconUrl:
          "https://storage.digital-enabler.eng.it/imgs/kpim/de_map_marker.svg",
        iconSize: [30, 40],
        iconAnchor: [10, 41],
        popupAnchor: [2, -40],
        shadowUrl:
          "https://storage.digital-enabler.eng.it/imgs/kpim/de_marker_shadow.png",
        shadowSize: [50, 64],
        shadowAnchor: [10, 66],
      }),
      credentials: L.tileLayer(
        "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        },
      ),
    };
  },
  methods: {
    //initialize the map and applies all other layers e.g markers
    initMap() {
      this.map = L.map("map-container", {
        dragging: false,
        scrollWheelZoom: "center",
        doubleClickZoom: false,
      });

      this.markerLayer = new L.LayerGroup();
      this.credentials.addTo(this.map);

      this.markerLayer.addTo(this.map);

      if (this.isNewKpi()) {
        this.map.setView([51.505, -0.09], 3);
      } else {
        const coordinates = { ...this.geolocation };
        this.setLatLng(coordinates);
        this.setMarker(coordinates);
      }
    },

    //helper function to check wether the user is creating a new kpi or editing an old one
    isNewKpi() {
      return this.geolocation.latitude == 0 || this.geolocation.longitude == 0;
    },

    //empty the map container
    clearMap() {
      this.map != undefined ? this.map.remove() : null;
    },

    //set the marker after localization
    setMarker(coordinates) {
      if (this.markerLayer.getLayers().length >= 1) {
        this.markerLayer.clearLayers();
      }
      this.marker = L.marker(
        {
          lat: coordinates.latitude,
          lng: coordinates.longitude,
        },
        {
          icon: this.icon,
        },
      ).addTo(this.markerLayer);
    },

    //extrapolate latitude and longitude from latlng object
    setLatLng(coordinates) {
      this.map.setView(
        L.latLng(coordinates.latitude, coordinates.longitude),
        16,
      );
    },

    //extrapolate latitude and longitude from latlng object
    setMapCentre(coordinates) {
      let zoom = this.map.getZoom() === undefined ? 16 : this.map.getZoom();
      this.map.setView(
        L.latLng(coordinates.latitude, coordinates.longitude),
        zoom,
      );
    },
  },
};
